import React from 'react'
import classes from './NotAvailable.module.css'
const NotAvailable = props => {
    return (
       <div className={classes['Container']}>Data Not NotAvailable</div>
    )
}



export default NotAvailable
